import { useForm } from 'react-hook-form';

// biome-ignore lint/suspicious/noExplicitAny: inherited from operator
export const useFormHook = (defaultValues: any) => {
    const {
        register,
        formState,
        reset,
        control,
        setValue,
        getValues,
        watch,
        getFieldState,
    } = useForm({
        defaultValues,
    });

    return {
        register,
        reset,
        formState,
        control,
        setValue,
        getValues,
        watch,
        getFieldState,
    };
};
